;(function (_, $) {

    $('.entry-content .woocommerce')
        .on('click', '.tpk-toggle-shipping-options', function () {
            $(this).closest('dd').addClass('visible');
        })

})(window, jQuery);